import { mainFeatures, ROUTES } from '../sidebar/menu-items';

export const PROPRIETOR_DEFAULT_ROUTE = ROUTES[mainFeatures.visits].path;
export const PROPRIETOR_ALLOWED_MAIN_FEATURES: readonly (keyof typeof mainFeatures)[] = [
  mainFeatures.frequentAccess,
  mainFeatures.administration,
  mainFeatures.reservations,
  mainFeatures.visits,
  mainFeatures.managementVisitsMacroBusiness,
  mainFeatures.notices
];

function buildProprietorAllowedPaths(): string[] {
  const paths: string[] = ['/app'];
  for (const key of PROPRIETOR_ALLOWED_MAIN_FEATURES) {
    const route = ROUTES[key];
    if (!route) continue;
    if (route.path) paths.push(route.path);
    if (route.submenu?.length) {
      route.submenu.forEach((sub: { path?: string }) => sub.path && paths.push(sub.path));
    }
  }
  const macroMgmt = ROUTES[mainFeatures.managementVisitsMacro]?.path;
  const businessMgmt = ROUTES[mainFeatures.managementVisitsMacroBusiness]?.path;
  if (macroMgmt) paths.push(macroMgmt);
  if (businessMgmt) paths.push(businessMgmt);
  return [...new Set(paths)];
}

/** Paths permitidos para el guard del rol propietario (derivados de ROUTES). */
export const PROPRIETOR_ALLOWED_PATHS: readonly string[] = buildProprietorAllowedPaths();

// Indica si una URL está permitida para el rol propietario.
export function isProprietorAllowedUrl(url: string): boolean {
  const normalized = url.split('?')[0];
  return PROPRIETOR_ALLOWED_PATHS.some((path) => normalized === path || normalized.startsWith(path + '/'));
}
